import React from "react";
import _ from "lodash";
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";

import {ArrowBack} from "@material-ui/icons";

import {InteractService} from "../../services";
import {
  getStepAnswer,
  getUID,
  isQuestionValid,
  showQuestionRequiredNote,
  validateCustomer,
  scrollToFirstElementOfClass,
  checkMinor,
  isESGEnabled, isNewDesignProcess, showSkipRequiredWarning, getErrorMsg
} from "../../utils";
import {brokerLogout} from "../../../Authentication/Auth/utils";
import Navigation from "../Navigation";
import {ESGProfileService} from "../../esg_profile_service";
import {CustomerService} from "../../customer_step_service";
import {ProductsService} from "../../products_step_service";
import {FinalizeService} from '../../finalize_step_service'
import {CustomerDataServiceV2} from "../servicesV2/customer_data_service";
import {CustomerAccountServiceV2} from "../servicesV2/account_data_service";
import {QuestionnairesHandlerResource} from "../../../../utils/api";
import { executeIfPathExist, getInvestmentDynamicPath } from '../../../InvestmentPlatform/utils'
import useStyles from './styles'
import ServiceConceptSelection from "../ServiceConceptSelection";
import {SERVICE_CONCEPTS, SERVICE_CONCEPTS_NAMES} from "../../../Trades/constants";
import {ExAnteService} from "../../exante_constants";
import {PrimaryButton} from "../../../../components/Buttons";
import {
  displayErrorSnackBar,
  displayWarningSnackBar
} from "../../../../components/SnackbarProvider/actions";
import {setRefreshHeaderTrigger} from "../../../InvestmentPlatform/actions";
import {
  ACCOUNT_DATA_SUCCESS_MSG,
  CONFIRM_REMOVE_MSG,
  COUPLE_MEMBERS_CONFIRMATION_STEP_IDENTIFIERS,
  OBJECT_TYPES,
  USER_CONFIRMATION_STEP_IDENTIFIER
} from "../../constants";
import ConfirmationDialog from "../../../VirtualPortfolioManager/modals/ConfirmationDialog";
import {ProtocolDataServiceV2} from "../servicesV2/protocol_data_service";
import {useConfirmationModalContext} from "../../../../components/ConfirmationModalContextProvider";
import MissingFieldsSummary from "../MissingFieldsSummary";
import {ProductsServiceV2} from "../servicesV2/products_service";
import ResendResultButton from "../StepContent/components/StepFooter/components/ResendResultButton";
import {getSubSystemConfigItem} from "../../../../utils/utils";
import {CustodyCertificateServiceV2} from "../servicesV2/custody_certificate_service_v2";
import ServiceConceptSelectionV2 from "../ServiceConceptSelectionV2";
import {useStepSkipping} from "../../hooks/useStepSkipping";
import {useUnsavedChangesGuard} from "../../hooks/useUnsavedChangesGuard";
import {
  initStepsAfterCurrent,
  initServiceNavigateBack,
  invalidateStaleMenus
} from "./utils";
import useMenuNavigation from "../../hooks/useMenuNavigation";

let currService;

const mapStateToProps = (state) => ({
  auth: state.get('auth').toJS(),
  investmentPlatform: state.get('investmentPlatform').toJS()
});

const setQuestionAnswer = (question, uid, answer) => {
  return question.map(question => {
    if (question.uid === uid) {
      question.answer = answer;

      if(question.afterChangeCallback){
        question.afterChangeCallback(currService)
      }
    }

    if (question.question) {
      question.question = setQuestionAnswer(question.question, uid, answer);
    }

    return question;
  })
};

const RiskProfilingDataProvider = WrappedComponent => {
  return withRouter(connect(mapStateToProps)(function dataProvider(props) {
    const {
      match: {
        params: {
          customer_id
        },
        url
      },
      auth: {
        user
      },
      history,
      newDesign: useNewDesignForNewSessions,
    } = props;

    const classes = useStyles();

    const _getStepService = (onboarind_step_uid) => {
      return menuItems.find(menu => menu.uid === onboarind_step_uid);
    };

    const _getStepAnswer = (onboarind_step_uid, step_uid, question_uid, withOption) => {
      const menu = _getStepService(onboarind_step_uid);
      if(menu){
        return menu.getStepAnswer(step_uid, question_uid, withOption);
      }
    };

    const esgEnabled = isESGEnabled();
    const isWithNewOtherAssets = getSubSystemConfigItem('reporting', 'useNewOtherAssets');

    const modalContext = useConfirmationModalContext();
    const [missingFieldsData, setMissingFieldsData] = React.useState(undefined);

    var handleCreateAccountClick = (validate, raiseExceptions=true) => {
      let data = {customer_id: customer_id, onboarding_uid: currService.onboarding_uid, validate: !!validate};
      menuItems.map(menuItem => {
        if(!validate || (menuItem.isDone || currService === menuItem)) {
          const userData = menuItem.getDataForAccount(validate) || {};
          _.merge(data, userData)
        }
      });

      // console.log(data);
      return QuestionnairesHandlerResource.at('create-account/')
        .post(data).then((response) => response)
        .catch((error) => {
          if (raiseExceptions) {
            throw error
          }

          return {
            error
          }
        });
    };

    const validateMissingData = () => {
      const missingData = [];
      menuItems.forEach(menuItem => {
        const missingMenuData = menuItem.getStepsValidationData();

        if(!_.isEmpty(missingMenuData)){
          missingData.push({
            uid: menuItem.uid,
            name: menuItem.name,
            steps: missingMenuData
          })
        }
      });

      if(!_.isEmpty(missingData)) {
        setMissingFieldsData(missingData);
        return false;
      } else {
        setMissingFieldsData(undefined);
        return true;
      }
    };

    const setServiceInitialData = (currService, prevService, onboarding_data) => {
      currService.customer_id = customer_id;
      currService.user = user;
      currService.serviceConcept = serviceConcept;
      if(prevService){
        currService.customer_type = prevService.customer_type;
        currService.bank = prevService.bank;
        if(!_.isEmpty(prevService.banksDataGrouped)) {
          currService.banksDataGrouped = prevService.banksDataGrouped;
        }
        currService.members = prevService.members;
        currService.current_customer = prevService.current_customer;
      }
      currService.isPortfolioBuilderFlow = _.has(onboarding_data.onboarding_answers, 'portfolio_builder.auto_portfolio_builder');
      if(serviceConcept){
        const lastProcess = (latestFinished || []).find(l => l.service_concept == serviceConcept);
        currService.prevProcessAnswers = lastProcess && lastProcess.onboarding_answers;
      }
      if(onboarding_data){
        // TODO: store ids / answers globally
        currService.onboarding_uid = onboarding_data.session_id;
        if(currService.uid !== 'user_confirmation') {
          // User Confirmation step is stored on our side - so do not set Interact session
          currService.session_id = onboarding_data.risk_session;
        }
        if(currService.uid === 'risk_profile' && serviceConcept === SERVICE_CONCEPTS.Anlageberatung) {
          currService.srri = null;
          if (!currService.session_id && riskProfile) {
            currService.session_id = riskProfile.session_id;
            currService.srri = riskProfile.srri;
          }
        }
      }
    }

    const handleValidateAccountClick = (raiseExceptions=false) => {
      return handleCreateAccountClick(true, raiseExceptions);
    };

    const handleWarnings = (warnings) => {
      const warnMsg = currService.parsePageWarnings(warnings);
      if(warnMsg && _.isString(warnMsg)){
        props.dispatch(displayWarningSnackBar(warnMsg));
      }
    };

    const [menuItems, setMenuItems] = React.useState([
      new InteractService('risk_profile', 'Risikoprofilierung', esgEnabled ? "Weiter zum Nachhaltigkeitsprofil" : "Weiter zur Produktauswahl",
        null, _getStepAnswer),
      ...(
        esgEnabled ? [
          new ESGProfileService('esg_profile', 'NACHHALTIGKEITSPROFIL', "Weiter zur Produktauswahl",
            <>
              Das Nachhaltigkeitsprofil des Kunden wurde erfolgreich gespeichert. Sie können diese Informationen
              auch unter Meine Kunden ansehen und bearbeiten.
            </>, _getStepAnswer)
        ] : []
      ),
      new ProductsService('products_selection', 'Produktauswahl', "Weiter zum Ex-Ante Kostenausweis",
        <>
          Die Produktauswahl wurde erfolgreich gespeichert.
        </>,
        _getStepAnswer, handleValidateAccountClick, handleWarnings),
      new ExAnteService('ex_ante_cost', 'Ex-Ante Kosten', customer_id, _getStepService),
      new CustomerService('user_data', 'Kundendaten', "Weiter zu Aufklärung & Protokoll",
        <>
          Die Kundendaten wurden erfolgreich gespeichert. Fahren Sie fort mit Aufklärung &
          Protokoll um den Prozess erfolgreich abschließen zu können.
        </>,
        _getStepAnswer, handleValidateAccountClick),
      new FinalizeService('protocol', 'Aufklärung & Protokoll', 'Zum Kundenprofil',
        <>
          Sie haben den Prozess erfolgreich abgeschlossen.
        </>,
        _getStepAnswer, handleCreateAccountClick)
    ]);

    const [step, setStep] = React.useState(null);
    const stepRef = React.useRef(step);
    const bypassGuardRef = React.useRef(false);
    stepRef.current = (!bypassGuardRef.current && currService && currService.isNewDesign) ? step : undefined;
    const [baselineVersion, setBaselineVersion] = React.useState(0);

    const [progress, setProgress] = React.useState(null);
    const [isLast, setIsLast] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [currMenu, setMenu] = React.useState(0);
    const [onboardingData, setOnboardingData] = React.useState(null);
    const onboardingDataRef = React.useRef(onboardingData);
    onboardingDataRef.current = onboardingData;
    const [latestFinished, setLatestFinished] = React.useState(null);
    const [riskProfile, setRiskProfile] = React.useState(null);
    const [serviceConcept, setServiceConcept] = React.useState(null);

    const investmentDynamicPath = React.useMemo(getInvestmentDynamicPath, []);
    const [resetSessionModalOpen, setResetSessionModalOpen] = React.useState(false);
    const [deleteSessionModalOpen, setDeleteSessionModalOpen] = React.useState(false);
    const [confirmJumpToAnlagevermittlungOpen, setConfirmJumpToAnlagevermittlungOpen] = React.useState(false);

    // Guards navigation away from a step with unsaved (unpersisted) changes.
    // "Next / Save & Continue" is not guarded - it persists and resets the baseline.
    const {guardUnsaved} = useUnsavedChangesGuard({
      currService,
      stepRef,
      setStep,
      modalContext,
      history,
      bypassGuardRef,
      baselineVersion,
    });

    React.useEffect(() => {
      currService = undefined;
      initData().catch(handleError);
    }, []);

    React.useEffect(() => {

      const _getStepAnswer = (onboarind_step_uid, step_uid, question_uid, withOption, asQuestion) => {

        const menu = menuItems.find(menu => menu.uid === onboarind_step_uid);
        if(menu){
          return menu.getStepAnswer(step_uid, question_uid, withOption, asQuestion);
        }
      };

      menuItems.forEach(item => {
        item._getPrevStepAnswer = _getStepAnswer;
        item._handleWarnings = handleWarnings;
        if(_.isFunction(item._createAccountFunc)){
          item._createAccountFunc = handleCreateAccountClick;
        }
        if(_.isFunction(item._validateAccountFunc)){
          item._validateAccountFunc = handleValidateAccountClick;
        }
        if(_.isFunction(item._validateMissingData)){
          item._validateMissingData = validateMissingData;
        }
        item._getStepService = _getStepService;
      })
    }, [menuItems]);

    const initStepData = async () => {
      let currentStep = currMenu;
      if (onboardingData.current_step){
        const menuIdx = menuItems.findIndex(i => i.uid === onboardingData.current_step);
        if(menuIdx !== -1){
          setMenu(menuIdx);
          currentStep = menuIdx;
          for(let i = 0; i < currentStep; i++) {
            // we need to init all prev steps with data from Onboarding
            await initService(i, onboardingData, true);
          }
        }
      }
      await _setCurrService(currentStep, false, onboardingData.last_finished_sub_step);

      await initStepsAfterCurrent(isNewDesign, setLoading, currentStep, menuItems, setServiceInitialData, onboardingData)
    };

    React.useEffect(() => {
      props.dispatch(setRefreshHeaderTrigger());
    }, [currMenu]);

    React.useEffect(() => {
      if(serviceConcept){
        initStepData().then(() => {
          props.dispatch(setRefreshHeaderTrigger());
        }).catch(handleError);
      }
    }, [serviceConcept]);

    React.useEffect(() => {

      validateQuestions(true)

    }, [JSON.stringify(step)])

    React.useEffect(() => {
      menuItems.forEach(item => {
        if (['risk_profile', 'user_confirmation'].includes(item.uid)) {
          item.onLegalDocumentsButtonClick = onDownloadLegalDocumentClick
          item._syncQuestions()
        }
      })
    }, [step])

    const initService = async (idx, onboarding_data, initOnly, isBack, lastFinishedStep) => {
      let prevService = currService
      currService = menuItems[idx];
      if(isBack) {
        await initServiceNavigateBack(currService, lastFinishedStep)

        return;
      }
      setServiceInitialData(currService, prevService, onboarding_data)
      // set final SRRI to answers
      if (onboarding_data.srri) {
        onboarding_data.onboarding_answers.srri = onboarding_data.srri;
      }

      // TODO: Remove session id usage from onboarding/trading
      // User Confirmation step is stored on our side - so do not set Interact session
      if(!currService.session_id && currService.uid !== 'user_confirmation') {
        currService.session_id = prevService && prevService._session_id;
      }

      await currService.initQuestionnaire(onboarding_data && onboarding_data.onboarding_answers, initOnly, lastFinishedStep);
      if(currService.warning){
        props.dispatch(displayWarningSnackBar(currService.warning));
        delete currService.warning;
      }
    };

    const _setCurrService = async (idx, isBack, lastFinishedStep) => {
      if(_.isNumber(idx)) {
        setLoading(true);
        try {
          await initService(idx, onboardingDataRef.current, false, isBack, lastFinishedStep);
          await updateState();
          setLoading(false);
        } catch (error) {
          handleError(error);
        }
      }
    };

    const updateState = async (skipped=false) => {
      if(currService.finished) {
        if(currService.isNewDesign && !skipped){
          const snackbarAction = currService.getFinishSnackbarAction();
          if(snackbarAction) {
            props.dispatch(snackbarAction);
          }
        }
        await _nextMenu();
      }
      setStep(currService.step);
      setIsLast(currService.isLastStep);
      setProgress(currService.progress);

      if (currService.step && currService.step.initStepAsync) {
        await currService.step.initStepAsync(currService);
      }
      setBaselineVersion(v => v + 1);
    };

    async function onDownloadLegalDocumentClick() {
      if (validateQuestions()) {
        try {
          setLoading(true);
          await currService.nextStep(true);
          setLoading(false);
          return true
        } catch (error) {
          handleError(error);
          return false
        }
      } else {
        return false
      }
    }

    const updateServiceConcept = (sc, newDesign) => {
      let stammdaten = new InteractService('user_confirmation', 'Stammdaten', null, null, _getStepAnswer);
      if(newDesign){
        console.log('Welcome to Onboarding v2.0!');
        stammdaten = new CustomerDataServiceV2('user_data', 'Stammdaten', undefined,
          undefined,
          _getStepAnswer, handleValidateAccountClick);
      }
      // update menu items according to service concept
      setMenuItems(prevMenuItems => {
        let hasCustodyCertificate = false;
        if(newDesign){
          prevMenuItems = prevMenuItems.map(menu => {
            if(menu.uid === 'user_data'){
              menu = new CustomerAccountServiceV2('user_account', 'Konto', null, ACCOUNT_DATA_SUCCESS_MSG, _getStepAnswer, handleValidateAccountClick, undefined, '')
            } else if (menu.uid === 'protocol'){
              menu = new ProtocolDataServiceV2(menu.uid, menu.name, menu.next_btn, menu.success_body, _getStepAnswer, handleCreateAccountClick, handleValidateAccountClick, validateMissingData)
            } else if(menu.uid === 'products_selection'){
              menu = new ProductsServiceV2(menu.uid, menu.name, menu.next_btn, menu.success_body, _getStepAnswer, handleValidateAccountClick, handleWarnings)
            } else if(menu.uid === 'custody_certificate'){
              const oldMenu = menu;
              menu = new CustodyCertificateServiceV2(oldMenu.uid, oldMenu.name);
              menu.customer_type = oldMenu.customer_type;
              menu.members = oldMenu.members;
              hasCustodyCertificate = true;
            }

            return menu;
          })
        }

        if (sc === SERVICE_CONCEPTS.ExecutionOnly) {
          const filtered = prevMenuItems.filter(item => item.uid !== 'esg_profile');
          // replace existing service with User Confirmation
          return filtered.map(menu => {
            if (menu.uid === 'risk_profile') {
              menu = stammdaten;
            }

            return menu;
          })
        } else if (sc === SERVICE_CONCEPTS.Anlagevermittlung) {
          let hasNewDesignStammdaten = false;
          const newMenus = prevMenuItems.map(menu => {
            // replace existing service with Knowledge and Expiriense
            if (menu.uid === 'risk_profile') {
              menu = new InteractService('risk_profile', 'Kenntnisse & Erfahrungen',
                "Weiter zur Produktauswahl", null, _getStepAnswer);
              menu.is_investment_questionnaire = true;
            }
            if (menu.isNewDesign && menu.name === 'Stammdaten'){
              hasNewDesignStammdaten = true;
            } else if(menu.uid === 'custody_certificate'){
              const oldMenu = menu;
              menu = new CustodyCertificateServiceV2(oldMenu.uid, oldMenu.name);
              menu.customer_type = oldMenu.customer_type;
              menu.members = oldMenu.members;
              hasCustodyCertificate = true;
            }

            return menu;
          }).filter(item => item.uid !== 'esg_profile');

          // add User Confirmation menu as first step if missing (old design)
          return hasNewDesignStammdaten
            ? newMenus
            : (hasCustodyCertificate ? [newMenus[0], stammdaten, ...newMenus.slice(1)] : [stammdaten, ...newMenus])
        }

        // in new design Stammdaten is also added for Anlageberatung
        return newDesign
          ? (hasCustodyCertificate ? [prevMenuItems[0], stammdaten, ...prevMenuItems.slice(1)] : [stammdaten, ...prevMenuItems])
          : prevMenuItems;
      });

      setServiceConcept(sc);
    };

    const initData = async () => {
      setLoading(true);
      if(!customer_id) brokerLogout();

      // get customer details - to check if customer exists
      const customer = await validateCustomer(customer_id, props.dispatch);
      const custodyService = checkMinor(customer, props.dispatch);
      if(custodyService){
        setMenuItems(prevMenuItems => {
          return [custodyService, ...prevMenuItems];
        })
      }

      const onboarding = await QuestionnairesHandlerResource.getLatestSession(customer_id);
      setOnboardingData(onboarding);
      try {
        let res = await QuestionnairesHandlerResource.at(`${customer_id}/get-last-srri/`).get();
        setRiskProfile(res);
      } catch (e) {
        // risk profile doesn't exist
      }
      try {
        let lastFinishedProcesses = await QuestionnairesHandlerResource.getLatestFinishedByServiceConcepts(customer_id, OBJECT_TYPES.ONBOARDING);
        if(lastFinishedProcesses){
          setLatestFinished(lastFinishedProcesses);
        }
      } catch (error) {
        // not critical as we use it just to pre-fill
      }

      const scStep = _.get(onboarding, 'onboarding_answers.service_concept_step');
      if(scStep){
        updateServiceConcept(scStep.service_concept, isNewDesignProcess(onboarding));
      } else {
        let queryParams = props.location.search;
        queryParams = new URLSearchParams(queryParams);

        if(queryParams.get('auto_portfolio_builder') && _.isEmpty(onboarding.onboarding_answers)){

          await QuestionnairesHandlerResource.post({
            customer_id: customer_id,
            onboarding_uid: onboarding.session_id,
            onboarding_step_uid: 'portfolio_builder',
            step_uid: 'auto_portfolio_builder',
            answers: true
          });

          await handleServiceConceptChanged(SERVICE_CONCEPTS.Anlageberatung, onboarding, useNewDesignForNewSessions);
        } else {
          setLoading(false);
        }
      }
    };

    const _nextMenu = async () => {
      if (currMenu < menuItems.length - 1){
        setLoading(true)

        const _currMenu = currMenu + 1
        await _setCurrService(_currMenu)
        setMenu(_currMenu)
        return currMenu;

      } else {
        // this is last step
        console.log('You have finished Onboarding.')

        executeIfPathExist(props.investmentPlatform.routes, 'ESIGN_STATUS', path => {
          props.history.push(`/${investmentDynamicPath}${path}`)
        })
      }
    };

    const _prevMenu = async () => {
      if(currMenu > 0){
        const _currMenu = currMenu - 1;
        await _setCurrService(_currMenu, true);
        setMenu(_currMenu);
      }
    };

    const syncOnboardingData = (data) => {
      if (data && data.is_onboarding) {
        onboardingDataRef.current = data;
        setOnboardingData(data)
      }
    };

    const handleNextClick = async () => {
      if (validateQuestions() && (!currService.checkHasMissingAnswers(step) || await showSkipRequiredWarning(modalContext, onboardingData.session_id))) {
        try {
          setLoading(true);
          const data = await currService.nextStep();
          syncOnboardingData(data);
          invalidateStaleMenus(menuItems, data, currMenu);
          await updateState();
          setLoading(false)
        } catch (error) {
          handleError(error);
        }
      } else{
        scrollToFirstElementOfClass()
      }
    }

    const handleGoToStepClick = async (step_uid) => {
      try {
        setLoading(true);
        syncOnboardingData(await currService.goToStep(step_uid));
        await updateState();
        setLoading(false);
      } catch (error) {
        handleError(error);
      }
    }

    const deleteCurrentProcess = async () => {
      await QuestionnairesHandlerResource.deleteQuestionnaire(currService.onboarding_uid)
    }

    const deleteAndGoBackToPreviousRout = async () => {
      await deleteCurrentProcess()
      bypassGuardRef.current = true;
      await goBackToPreviousRout()
    }

    const handlePrevClick = async () => {
      try {
        setLoading(true);
        if(currService.isFistStep){
          if (currMenu == 0 && ['risk_profile', 'user_confirmation', 'user_data', 'custody_certificate'].includes(currService.uid)) {
            setLoading(true)
            try {
              await handleJumpToServiceConceptSelection()
            } catch (error) {
              console.error(`Error during deletion of questionnaire with uid ${currService.onboarding_uid}`)
            }
            setLoading(false)
          } else {
            await _prevMenu();
          }
        } else {
          await currService.prevStep();
          await updateState();
        }
        setLoading(false);
      } catch (error) {
        handleError(error);
      }
    }

    const handleResendResultClick = async () => {
      try {
        setLoading(true);
        await currService.resendResult();
        await updateState();
        setLoading(false);
      } catch (error) {
        handleError(error);
      }
    }

    const handleConfirmResultClick = async (data) => {
      try {
        // this comparison needed for cases, when menu has more than one confirmation steps
        const isDone = currService.isDone
        if (!isDone) {
          setLoading(true);
        }
        await currService.confirmResult(data);
        await updateState();
        // this comparison needed for cases, when menu has more than one confirmation steps
        if (!isDone) {
          setLoading(false);
        }
      } catch (error) {
        handleError(error);
      }
    }

    const stepRequired = step && step.question && step.question.some(showQuestionRequiredNote);

    const validateQuestions = (afterChange=false) => {

      let isValid = true;

      if (step && step.question) {
        let questions = [...step.question];

        questions.forEach(q =>  {

          if (afterChange && !q.validateImmediately) {
            return
          }

          let isQValid = isQuestionValid(q, step, afterChange, currService);

          isValid = !isValid ? false : isQValid
        });

        setStep({
          ...step,
          question: questions
        })
      }

      return isValid
    };

    const handleStepAnswerChange = (uid, answer) => {
      setStep((prevStep) => ({
        ...prevStep,
        question: setQuestionAnswer(prevStep.question, uid, answer)
      }));
    };

    const handleError = (error) => {
      function parseError(errorData) {
        if(errorData.errors){
          currService.setFormErrors(errorData.errors);
        }

        props.dispatch(displayErrorSnackBar(getErrorMsg(errorData, error)));
      }

      switch (error.status) {
        case 401:
        case 403:
          brokerLogout();
          return;
        default:
          parseError(error.data || error);
      }

      setLoading(false); // re-render should be after we setFormErrors
    };

    const navigateToMenu = useMenuNavigation({
      currMenu, menuItems, setServiceInitialData, onboardingData, syncOnboardingData, setLoading, handleError,
      setCurrService: _setCurrService, setMenu, setMissingFieldsData
    });
    const {handleSkipClick, skipBtn} = useStepSkipping(
      currService, setLoading, syncOnboardingData, updateState, handleError, guardUnsaved, step
    );

    // Guarded navigation wrappers: warn + revert on unsaved changes before leaving the step.
    // Next / Save & Continue stays unguarded (it persists).
    const guardedPrevClick = guardUnsaved(handlePrevClick);
    const guardedGoToStepClick = guardUnsaved(handleGoToStepClick);
    const guardedNavigateToMenu = guardUnsaved(navigateToMenu);

    const initWithNewDesign = useNewDesignForNewSessions && !!onboardingData && _.isEmpty(onboardingData.onboarding_answers);

    const handleServiceConceptChanged = async (sc, onboarding, newDesign=false, init=true) => {
      if (loading) return; // prevent double-click
      setLoading(true);

      try {
        const session_id = _.get(onboardingData, 'session_id') || _.get(onboarding, 'session_id');
        newDesign = newDesign || initWithNewDesign;

        await QuestionnairesHandlerResource.post({
          customer_id: customer_id,
          onboarding_uid: session_id,
          onboarding_step_uid: 'service_concept_step',
          step_uid: 'service_concept',
          answers: sc
        });

        // init new process with dummy step to mark new processes
        if (init && (newDesign || isWithNewOtherAssets)){
          const res = await QuestionnairesHandlerResource.post({
            customer_id: customer_id,
            onboarding_uid: session_id,
            onboarding_step_uid: newDesign ? 'new_design_dummy_step' : 'new_other_assets_dummy_step',
            step_uid: 'new_design',
            answers: true
          });

          setOnboardingData(res);
        }

        updateServiceConcept(sc, newDesign);
      } catch (error) {
        handleError(error);
      }
    };

    const goBackToPreviousRout = async () => {
      /** Returns you to page from which you were redirected here */

      // if you start the process, clear browser history, props.history.length would be set, but you won't be able to redirect => use window.history
      let hasHistory = window.history.length > 1;

      if(!hasHistory) {
        executeIfPathExist(props.investmentPlatform.routes, useNewDesignForNewSessions ? 'RISK_PROFILING_V2' : 'RISK_PROFILING', path => {
          props.history.push(`/${investmentDynamicPath}${path}`)
        })
      } else {
        props.history.goBack()
      }
    };

    const isNewDesign = initWithNewDesign || isNewDesignProcess(onboardingData);

    // show Service concept screen ONLY after onboarding data loaded
    if (!loading && serviceConcept === null && !!onboardingData) {
      // TODO: if initWithNewDesign use new design for ServiceConceptSelection
      const ServiceConceptSelectionComponent = isNewDesign ? ServiceConceptSelectionV2 : ServiceConceptSelection;
      if(isNewDesign){
        console.log('Welcome to Onboarding v2.0!')
      }
      return <ServiceConceptSelectionComponent
        onServiceConceptChange={handleServiceConceptChanged}
        footerContent={(
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingTop: 45}}>
            <PrimaryButton
              text={"Zurück"}
              icon={<ArrowBack color={'primary'}/>}
              variant={"outlined"}
              onButtonClick={goBackToPreviousRout}
              customClasses={{
                root: classes.scBackButtonRoot
              }}
            />
          </div>
        )}
      />
    }

    const title = SERVICE_CONCEPTS_NAMES[serviceConcept] || "Onboarding";

    // Jump from Anlageberatung to Anlagevermittlung functionality
    const handleJumpToAnlagevermittlung = async () => {
      setConfirmJumpToAnlagevermittlungOpen(false);
      // pre-fill answers
      const _getStepData = (stepUID) => {
        const step = currService.getStep(stepUID);

        return step && _.get(getStepAnswer(step), 'answers');
      };

      // add answers for Anlagevermittlung and clean "current_step"
      const data = {...onboardingData, current_step: undefined};
      [USER_CONFIRMATION_STEP_IDENTIFIER, ...COUPLE_MEMBERS_CONFIRMATION_STEP_IDENTIFIERS].map(stepUID => {
        _.set(data, `onboarding_answers.user_confirmation.${stepUID}`, _getStepData(stepUID));
      });
      _.set(data, "onboarding_answers.risk_profile.K1", _getStepData('A2'));
      _.set(data, "onboarding_answers.risk_profile.K2", _getStepData('A3'));
      _.set(data, "onboarding_answers.risk_profile.K21", _getStepData('A21'));
      _.set(data, "onboarding_answers.risk_profile.K22", _getStepData('A22'));

      setOnboardingData(data);
      // start from beginning
      const riskProfilingMenuIdx = menuItems.findIndex(menu => menu.uid === 'risk_profile');
      setMenu(riskProfilingMenuIdx);

      await handleServiceConceptChanged(SERVICE_CONCEPTS.Anlagevermittlung, undefined, undefined, false);
    };

    // TODO: Check, if selected solution is correct
    const handleJumpToServiceConceptSelection = async () => {
      await deleteCurrentProcess();
      history.replace({ pathname: "/empty" }); // to make sure next history.replace will trigger url change/reload
      let pathName = url;
      if(!useNewDesignForNewSessions && isNewDesignProcess(onboardingData)){
        const customerParam = ':customer_id';
        executeIfPathExist(props.investmentPlatform.routes, 'RISK_PROFILING_V2', (path) => {
          pathName = `/${investmentDynamicPath}${path.replace(customerParam, customer_id)}`;
        }, customerParam)
      }
      // new react stack updates so need to move in timeout to move into new event loop
      setTimeout(() => {
        history.replace({ pathname: pathName });
      }, 0);
      currService = undefined;
    };

    let rightButtons = [];
    if (serviceConcept === SERVICE_CONCEPTS.Anlageberatung && ['A5', 'A7'].includes(getUID(_.get(currService, 'step.uid', '')))) {
      rightButtons = [
        <PrimaryButton
          text={"Vermittlung"}
          icon={<i className={"far fa-sync-alt"} style={{fontSize: '0.8em'}}/>}
          variant={"outlined"}
          onButtonClick={() => setConfirmJumpToAnlagevermittlungOpen(true)}
        />
      ]
    } else if (serviceConcept === SERVICE_CONCEPTS.ExecutionOnly
        && getUID(_.get(currService, 'step.uid', '')) === (_.get(currService, 'isNewDesign') ? 'product-selection-deposits' : 'product-selection-depot')
        && currService.hasPrivateInvestmentDepots) {

      rightButtons = [
        <PrimaryButton
          text={"Abbrechen & wechseln"}
          variant={_.get(currService, 'isNewDesign') ? 'outlined' : undefined}
          onButtonClick={() => setResetSessionModalOpen(true)}
        />
      ]

    }

    const onDeleteClick = () => setDeleteSessionModalOpen(true);

    if(isNewDesign){
      rightButtons.unshift(
        <PrimaryButton
          text={"Abbrechen"}
          color={'secondary'}
          variant={'outlined'}
          onButtonClick={onDeleteClick}
        />
      );
      const resendResultBtnLabel = currService && currService.resendResultBtnLabel;
      if(resendResultBtnLabel){
        rightButtons.push(
          <ResendResultButton
            name={resendResultBtnLabel}
            isNewDesign={isNewDesign}
            onResendResultClick={handleResendResultClick}
          />
        )
      }
      if(skipBtn) {
        rightButtons.push(skipBtn);
      }
      rightButtons.push(
        <PrimaryButton
          text={"Zurück"}
          variant={"outlined"}
          onButtonClick={guardedPrevClick}
        />
      );
    }

    return (
      <>
        {!!currService && (
          <Navigation
            title={title}
            menuItems={menuItems}
            currMenu={currMenu}
            onDeleteProcessClick={!isNewDesign ? onDeleteClick : undefined}
            isFinished={!!_.get(onboardingData, 'finished')}
            navigateToMenu={isNewDesign && !loading ? guardedNavigateToMenu : undefined}
          />
        )}
        <WrappedComponent
          onNextClick={handleNextClick}
          onPrevClick={guardedPrevClick}
          onSkipClick={handleSkipClick}
          onGoToStepClick={guardedGoToStepClick}
          onResendResultClick={handleResendResultClick}
          onConfirmResultClick={handleConfirmResultClick}
          onAnswerChange={handleStepAnswerChange}
          step={step}
          progress={progress}
          isFirst={currService && currService.goBackDisabled || false}
          isLast={isLast}
          loading={loading}
          required={stepRequired}
          valid={true} //TODO: Check, if this param is used
          successBody={currService && currService.success_body}
          nextStepBtnText={currService && currService.next_btn}
          dataService={currService}
          extraRightButtons={rightButtons}
          isNewDesign={isNewDesign}
        />
        <ConfirmationDialog
          title={!resetSessionModalOpen && 'Beratung beenden'}
          message={resetSessionModalOpen ? "Sind Sie sicher?" : CONFIRM_REMOVE_MSG}
          open={resetSessionModalOpen || deleteSessionModalOpen}
          onClose={() => resetSessionModalOpen ? setResetSessionModalOpen(false) : setDeleteSessionModalOpen(false)}
          confirm={resetSessionModalOpen ? handleJumpToServiceConceptSelection : deleteAndGoBackToPreviousRout}
          confirmButtonText={!resetSessionModalOpen && 'Ja, beenden & verwerfen'}
        />
        <ConfirmationDialog
          title={'Servicekonzept wechseln'}
          message={'Möchten Sie wirklich zur Anlagevermittlung wechseln?'}
          open={confirmJumpToAnlagevermittlungOpen}
          onClose={() => setConfirmJumpToAnlagevermittlungOpen(false)}
          confirm={handleJumpToAnlagevermittlung}
          confirmButtonText={'Ja, wechseln'}
        />
        <MissingFieldsSummary
          missingFieldsData={missingFieldsData}
          navigateToPrevMenu={navigateToMenu}
          handleClose={() => setMissingFieldsData(undefined)}
        />
      </>
    );
  }))
};

// function Confirm

export default RiskProfilingDataProvider;